export default __webpack_public_path__ + "static/media/Malassadas.7a51f330.jpg";